import { render, staticRenderFns } from "./PrintBox.vue?vue&type=template&id=27cc9da7&scoped=true&"
import script from "./PrintBox.vue?vue&type=script&lang=js&"
export * from "./PrintBox.vue?vue&type=script&lang=js&"
import style0 from "./PrintBox.vue?vue&type=style&index=0&id=27cc9da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cc9da7",
  null
  
)

export default component.exports